<template>
  <a-form-model ref="findPwdForm" :model="form" :rules="rules">
    <a-form-model-item prop="phone">
      <a-input v-model="form.phone" :placeholder="$t('message.phoneErr')">
        <a-icon slot="prefix" type="mobile" style="color:rgba(0,0,0,.25)" />
      </a-input>
    </a-form-model-item>
    <a-form-model-item prop="code">
      <a-input-search
        v-model="form.code"
        :placeholder="this.$t('message.codeErr')"
        @search="sendCode"
      >
        <a-icon slot="prefix" type="safety" style="color:rgba(0,0,0,.25)" />
        <a-button :disabled="sendBtn" type="primary" slot="enterButton">{{sendBtnTitle}}</a-button>
      </a-input-search>
    </a-form-model-item>
    <a-form-model-item prop="password">
      <a-input-password v-model="form.password" :placeholder="$t('message.pwdErr')">
        <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
      </a-input-password>
    </a-form-model-item>
    <!-- <a-form-model-item  prop="reInputPassword">
      <a-input-password v-model="form.reInputPwd" :placeholder="$t('message.reInputPwd')" >
        <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
      </a-input-password>
    </a-form-model-item>-->
    <a-form-model-item>
      <a-button
        block
        type="primary"
        size="large"
        @click="resetPwd"
      >{{this.$t('login.resetPassword')}}</a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { resetPwd } from "@/api/user.js";
import { sendSms } from "@/api/index.js";
import { validatephone } from "@/utils/validate";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

export default {
  data() {
    let phoneCheck = (rule, value, callbackFn) => {
      // const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!validatephone(value)) {
        callbackFn(this.$t("form.common.field.phone.checkMessage"));
        return;
      }
      callbackFn();
    };
    return {
      hasErrors,
      form: {},
      rules: {
        phone: [
          {
            required: true,
            message: this.$t("message.phoneErr"),
            trigger: "blur",
          },
          { validator: phoneCheck, trigger: "blur" },
        ],
        code: [
          {
            required: true,
            message: this.$t("message.codeErr"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("message.pwdErr"),
            trigger: "blur",
          },
        ],
        // reInputPwd:[{required:true,message:this.$t("message.reInputPwd"),trigger: "blur",}],
      },
      sendBtn: false,
      sendBtnTitle: this.$t("message.sendCode"),
      countDown: 60,
    };
  },

  computed: {},
  mounted() {},
  methods: {
    onClickForCode() {},
    clickToLogin() {
      this.$emit("toLogin");
    },
    sendCode() {
      // const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (this.form.phone == "") {
        this.$message.error(this.$t("message.phoneErre"), 2);
      } else if (!validatephone(this.form.phone)) {
        this.$message.error(this.$t("message.phoneErr"), 2);
        return;
      }
      let timeOut = setInterval(() => {
        this.sendBtn = true;
        this.sendBtnTitle = this.countDown + this.$t("message.sendAwait");
        if (this.countDown <= 0) {
          window.clearInterval(timeOut);
          this.countDown = 60;
          this.sendBtn = false;
          this.sendBtnTitle = this.$t("message.sendCode");
        }
        this.countDown--;
      }, 1000);
      sendSms({ phone: this.form.phone }).then((res) => {
        if (res.code == 1) {
          this.form.key = res.key;
        }
      });
    },
    resetPwd() {
        this.$refs.findPwdForm.validate((valid) => {
          if (valid) {
            resetPwd(this.form)
              .then((res) => {
                if (res.code == 1) {
                  this.$message.success(this.$t("message.resetPwdSuccess"), 2);
                  setTimeout(()=>this.$emit('login'),2000)              
                }
              })
              .catch((err) => {
                console.log("==err=", err);
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.options {
  text-align: center;
}

@media screen and (min-width: 768px) {
  .title {
    line-height: 6;
    text-align: center;
  }
  .content {
    width: 400px;
    margin: 60px auto 0;
    padding: 50px 50px 30px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
    vertical-align: middle;
  }
}

@media screen and (max-width: 768px) {
  .title {
    line-height: 6;
    text-align: center;
  }
  .content {
    width: 100%;
    margin: 0 auto 0;
    padding: 50px 50px 30px;
    box-shadow: none;
  }
}
</style>